import React,{ Component } from 'react';

import FloatingWindowLayout from '../../../shared/components/FloatingWindowLayout';
import Button from '../../../shared/components/Button';
import Form from '../../../shared/components/Form';
import TextInput from '../../../shared/components/TextInput';
import VersionTag from '../../../shared/components/VersionTag';

import { ACTIVE_PROFILE } from '../../../config';
import { parseQueryString } from '../../../shared/utils';


class SetPassword extends Component {
  constructor(){
    super();

    this.state = {
      authenticating:false,
      match:true,
      error:null,
      validationMessages:{}
    };
  }

  componentWillMount(){
    const query = parseQueryString(this.props.location.search);

    if('token' in query && 'userId' in query){
      this.setState({
        token:query.token,
        userId:query.userId
      });
    }
  }

  handleChange(){
    if(this.state.error || !this.state.match){
      this.setState({
        error:null,
        match:true
      });
    }
  }

  handleSubmit(data){
    const { confirmation, password } = data,
      { userId, token } = this.state,
      validationMessages = {};


    if(!password){
      validationMessages['password'] = 'Password is required';
    }

    if(password && password.length < 8){
      validationMessages['password'] = 'Password must be at least 8 characters in length';
    }

    if(!confirmation || confirmation !== password){
      validationMessages['confirmation'] = 'Confirmation does not match password';
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
    } else {
      this.setState({validationMessages:{}});
      this.props.resetPasswordForUser(userId,password,token)
        .then(() => this.handleSuccess())
        .catch((err) => this.handleError(err))
    }
  }

  handleSuccess(){
    this.props.history.push('/login');
  }

  handleError(error){
    this.setState({error:error});
  }

  render(){
    const {
      environment,
      frontEndVersion,
      backEndVersion
    } = this.props;

    const { validationMessages, token, userId } = this.state;


    if(!token || !userId){
      return (
        <div className='FloatingWindowLayoutBackdrop'>
          {ACTIVE_PROFILE !== 'prod' && ( 
            <VersionTag 
              environment={environment}
              frontend={frontEndVersion}
              backend={backEndVersion}
            /> 
          )}
          <FloatingWindowLayout title='Bad Link :(' />
        </div>
      );
    }

    return (
      <div className='FloatingWindowLayoutBackdrop'>
        {ACTIVE_PROFILE !== 'prod' && ( 
          <VersionTag 
            environment={environment}
            frontend={frontEndVersion}
            backend={backEndVersion}
          /> 
        )}
        <FloatingWindowLayout title='Set Password'>
          <Form onSubmit={(data) => this.handleSubmit(data)}>
            <TextInput
              label='Password'
              name='password'
              placeholder='123abc!@#'
              warning={validationMessages['password']}
              hidden
            />
            <TextInput
              label='Confirmation'
              name='confirmation'
              placeholder='123abc!@#'
              warning={validationMessages['confirmation']}
              hidden
            />
            <Button className='float-right' isSubmit>
              Submit
            </Button>
          </Form>          
        </FloatingWindowLayout>
      </div>
    )
  }
}

export default SetPassword;



// WEBPACK FOOTER //
// ./src/routes/SetPassword/components/SetPassword.js